import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { Body } from './components/Body';
import useViewportWidth from './hooks/useViewportWidth';
import { closeIndividualStudentGradebook } from '../../../actions/individualStudentGradebook';
import { useDetectBackNavigation } from './hooks/useDetectBackNavigation';
import { useSearchParams } from './hooks/useSearchParams';
import { getRoundPercentTypeValue } from './utils';
import { IsgProvider } from './store';
import { GRADEBOOK_SETTINGS } from '@macmillan-learning/gradebook-shared';
import { formatDisplayPercentage } from '../../../utils/InstructorGradebookHelpers';

import s from './IndividualStudentGradebook.module.css';

const IndividualStudentGradebookChat = ({
  studentGradebook,
  settings,
  user,
  getLaunchUrl,
  handleLocalLaunch,
  getStudentReportLink,
  timeOnTaskMap,
  hasStudentReport,
}) => {
  const { isMobile } = useViewportWidth();
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  useDetectBackNavigation(() => dispatch(closeIndividualStudentGradebook()));

  const studentId = studentGradebook.student.studentId;
  const showPercent = params.get('showPercent') === 'true';

  const roundPercent = getRoundPercentTypeValue(settings);
  const { course: courseData } = studentGradebook;

  const { grade, pointsEarned, pointsPossible } = courseData;
  const courseTotalPercent = formatDisplayPercentage(
    grade * 100,
    roundPercent || GRADEBOOK_SETTINGS.roundPercentHundredths,
  );

  const commonProps = {
    courseGrade: grade,
    courseTotalPointsEarned: pointsEarned,
    courseTotalPointsPossible: pointsPossible,
    courseTotalPercent: courseTotalPercent,
    showPercent: showPercent,
    latestActivityLaunch: null,
  };

  return (
    <IsgProvider>
      <div
        className={classNames(
          s.dialogWrapperChat,
          'individual-student-gradebook-scope',
        )}
        data-test-id="individual-student-gradebook-modal"
      >
        <Body
          isMobile={isMobile}
          gradebookData={studentGradebook}
          timeOnTaskMap={timeOnTaskMap}
          settings={settings}
          user={user}
          studentId={studentId}
          getLaunchUrl={getLaunchUrl}
          handleLocalLaunch={handleLocalLaunch}
          getStudentReportLink={getStudentReportLink}
          hasStudentReport={hasStudentReport}
          showPercent={showPercent}
          {...commonProps}
          isDropdownOpen={false}
        />
      </div>
    </IsgProvider>
  );
};

export default IndividualStudentGradebookChat;
